import { Component, ViewChild, EventEmitter, Output, NgZone } from '@angular/core';
import { Menu, DProduct, CommonService, DService, OuterMenu } from './Services/common.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSidenav } from '@angular/material';
import { CommonComponents } from './Sharedservice/CommonComponents';
import { SharedService } from './Sharedservice/SharedService';
import { IPatientSearch } from './models/IPatientSearch.model';
import { configuration } from 'src/environments/environment';
import { LockService } from './Services/LockService/lock-service.service';
import { MatMenuTrigger } from '@angular/material';
import { CheckedinComponent } from './Calender/checkedin/checkedin.component';
import { MatDialog } from '@angular/material/dialog';
import { PatientBannerService } from './patient-banner/patient-banner.service';
import { ToastrService } from 'ngx-toastr';
import { ILocationDetails } from './models/ILocationDetails';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionStorage } from 'angular-web-storage';
import { PatientSearchComponent } from './patient-search/patient-search.component';
import { ILoginSessionByLoginUser } from './models/IUsersDetails';
import { TasksandmessagesTabComponent } from './message/tasksandmessages-tab/tasksandmessages-tab.component';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { AuditLog } from './models/iauditlog.model';
import { BehaviourSerService } from './behaviour-ser.service';
import { SchedularServiceService } from './Services/Schedular/schedular-service.service';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { SlideInOutAnimation } from './animations';
import { DomSanitizer } from '@angular/platform-browser';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [SlideInOutAnimation]
})
export class AppComponent {

  public menustatus: boolean;
  @ViewChild('patsearchslider', null) public sidenav: MatSidenav;
  @ViewChild('patsearchslider1', null) public sidenav1: MatSidenav;
  @ViewChild('menuslider', null) public menuslider: MatSidenav;
  @Output() sidenavClose = new EventEmitter();
  @ViewChild('PatientSearch', { static: false }) patsrch: PatientSearchComponent;
  @ViewChild('taskMessage', { static: false }) taskandmessage: TasksandmessagesTabComponent;
  searchfrombanner: string = "AppComp";
  searchfrombanner1: string = "AppComp1";
  private previousTrigger: MatMenuTrigger;
  public noInternetConnection;
  public username;
  public serverDateTime;
  public clinictoken;
  public usertoken;
  servDateTimeLocalx;
  localdatetimerunner;
  public activUrl = 'assets/images/menu1/bg.svg';
  public isLoggedIn$ = false;
  public patid = 0;
  pptooltip = 'Quick Navigation to Patient Board';
  showFiller = true;
  showFiller2 = true;
  menuitems: Menu[];
  simpleProducts: string[];
  dproducts: DProduct[];
  data: any;
  public prodid: number;
  public selectMenuName: string;
  outermenulist: OuterMenu[] = [];
  public localmenus;
  showFirstSubmenuModes: any;
  showSubmenuModes2: any;
  currentProduct: OuterMenu;
  products: OuterMenu[];
  userDetails: any;
  static token: any;
  token = "Av1qwnsfb2TOzj4Lk00vBiH-niEhwbFRC8gA09CNKfTWqlq9MfQIHFGoNIzKEaoapIfT6KCXUuqi1MdTOaA_WbtBNpa02Aq0pY4cwCpqgHWP1GqaI-CdjzjqAT-s8u_fvc_vdl7otG9EtCeMhcLCA6CRLvyGcmSfO5Z1uaw891SOI5PuUFc_tP7qzCMyIdA82lPtB29MxcTFZuywFz7lf3tK-fA8BVNIGKfJ01XiGXFCBXSfvKddfC6BrJOJJoVL";
  imgflag: boolean;
  imgflag2: boolean;
  router: Router;
  facilities: any;
  patientId: number;
  patGender: string;
  PatName: string;
  patDOB: string;
  patientInfo: IPatientSearch;
  apiurl: '';
  isbannershow: boolean = true;
  IsMsgandTask: boolean = configuration.IsTaskAndMessages;
  ISCheckInternetConnection: boolean = configuration.CheckInternetConnection
  ISONCEnabled: boolean = configuration.ISONCEnabled
  EmergencyAccessInterval;
  changedLocationId: any;
  setSignaturePOPUrl: string = configuration.signaturePOPUrl;
  videoResourcesUrl: string = configuration.videoResourcesUrl;

  constructor(private formBuilder: FormBuilder,
    private behaserv: BehaviourSerService,
    menuservice: CommonService,
    public dialog: MatDialog,
    smallmenu: DService,
    private route: Router,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private lockService: LockService,
    private bannerService: PatientBannerService
    , private dateservice: SchedularServiceService
    , private toastr: ToastrService
    , private ngZone: NgZone
    , private TasksMessageService: TasksAndGroupsService
    , private cookieService: CookieService) {
    window.addEventListener("beforeunload", function (e) {
      // alert('beforeunload');
    });
    if (performance.navigation.type == PerformanceNavigation.TYPE_RELOAD) {
      //Reload
      //alert('Reloaded');
    }
    if (performance.navigation.type == PerformanceNavigation.TYPE_BACK_FORWARD) {
      //Back Button
      // alert('Back/Forward');
    }
    //*** get SignaturePOP url */
    document.getElementById("signaturePOPId")['value'] = this.setSignaturePOPUrl;

    this.username = sessionStorage.getItem("username");
    this.router = route
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        let Url = event.url.substring(1);


        localStorage.setItem("activeurl", Url);

      }

      if (event instanceof NavigationStart) {
        this.isbannershow = (event.url != "/Appointments")
        if (!this.isbannershow) {
          sessionStorage.removeItem("patientId");

        }
      }
      if (event instanceof NavigationEnd) { }
      if (event instanceof NavigationError) { }
    });
    // let mywindow
    // function closeinternet() {
    //   mywindow.close();
    //}
    function close_window(noInternetConnection) {
      document.getElementById("noInternetConnection").style.display = 'none';
     }
  
    this.showFiller = true;
    this.imgflag = false;
    this.imgflag2 = false;
    this.apiurl = configuration.apiUrl;
    this.dproducts = smallmenu.getProducts();
    //for getting facility salt
    if (sessionStorage.getItem("userId") != null && sessionStorage.getItem("userId") != undefined && sessionStorage.getItem("userId") != '') {
      if (sessionStorage.getItem('FacilityId') != null || sessionStorage.getItem('FacilityId') != undefined || sessionStorage.getItem('FacilityId') != '') {
        this.sharedService.getFacilityDetailsById(Number(sessionStorage.getItem('FacilityId')), sessionStorage.getItem("userId")).subscribe(results => {
          if (results != null) {
            configuration.key = results.clientsalt;
            configuration.iv = results.clientkey;
          }
          this.getmainMenuList();
          if (this.lstLocations.length == 0) {
            if (sessionStorage.getItem('UserLocations') != null && sessionStorage.getItem('UserLocations') != undefined) {
              this.lstLocations = JSON.parse(sessionStorage.getItem('UserLocations'));
              this.getLocationsByloginUser();
            }
            else {
              this.getUserLocations();
              //this.getLocationsByloginUser();
            }
          }
        }
          ,
          (err: any) => console.log(err)
        );
      }
    }


    if (sessionStorage.getItem("role") == 'Admin' || sessionStorage.getItem("role") == "Clerk") {
      this.dproducts = this.dproducts.filter(a => a.Name !== 'Settings')
    } else {
      this.dproducts = smallmenu.getProducts();
    }

    this.selectedLocation.locationName = '';
    this.menuitems = menuservice.getMenus();
    this.showSubmenuModes2 = [{
      name: "onHover",
      delay: { show: 0, hide: 500 }
    }, {
      name: "onClick",
      delay: { show: 0, hide: 300 }
    }];

    this.showFirstSubmenuModes = this.showSubmenuModes2[0];

  }

  InternetShow: boolean = false
  toggleShowDiv() {
    this.InternetShow = !this.InternetShow
    this.IsTaskMessage = false;
    this.sidenav1.close();//    this.patsearchslider1.open();
    this.sidenav.close();
  }

  fnLoadRightUserMenuData() {
    if (this.checkSession())
      return this.fnEnableEmergencyAccess();
    return null;
  }
  IsTaskMessage = false;
  callTaskmessages() {
    if (sessionStorage.getItem("TaskMessage") != undefined && sessionStorage.getItem("TaskMessage") != null) {
      if (sessionStorage.getItem("TaskMessage") == 'true' && this.route.url == "/tasksandmessages") {
        this.toastr.error('You are currently in the Messages>>Tasks section.  Hence Quick Launch Tasks pop-up shall not appear.')
        this.sidenav.close();
        return false;
      } else {
        this.TaskandMessagesValidation();
      }
    } else {
      this.TaskandMessagesValidation();
    }

  }
  search() {
    this.sidenav1.close()
    this.InternetShow = false;
  }
  TaskandMessagesValidation() {
    this.IsTaskMessage = true;
    this.InternetShow = false;
    this.sidenav1.open();//    this.patsearchslider1.open();
    this.sidenav.close();
    this.taskandmessage.fnSetLocationFromParent();// this.taskMessage.fnSetLocationFromParent()
  }

  LocationForm: FormGroup;

  fnCallParentFromNewAppointments() {
    document.getElementById("openmethos").click();
  }

  intervelTime: number = configuration.IntervalTime;
  intcheck;
  resetTaskInterval() {
    clearInterval(this.intcheck);
    this.intcheck = setInterval(() => {
      this.getcountTaskMessages();
    }, this.intervelTime);
  }
  fnsetInterval() {
    this.intcheck = setInterval(() => {
      clearInterval(this.intcheck);
      this.getcountTaskMessages();
      document.getElementById("btnchkTask").click();
    }, this.intervelTime);
  }
  ngOnInit() {
    if (this.IsMsgandTask) {
      this.getcountTaskMessages();
      this.ngZone.runOutsideAngular(() => {
        this.fnsetInterval();
      })
    }

    this.LocationForm = this.formBuilder.group({
      ServiceSite: [''],
      facilityName: ['']
    });

    this.behaserv.islocationChangedTime.subscribe((changelocationId) => {
      if (sessionStorage.getItem("LocationId") != null && sessionStorage.getItem("LocationId") != undefined) {
        if (changelocationId != '0') {
          this.changedLocationId = Number(changelocationId);
        } else {
          this.changedLocationId = sessionStorage.getItem("LocationId");
        }
        sessionStorage.setItem("LocationId", this.changedLocationId);
        this.LocationForm.patchValue({
          ServiceSite: this.changedLocationId,
        })
        this.OnNavigateLocationChanges(this.changedLocationId);
      }
    });


    var ServerTimeInterval = setInterval(() => {
      if (sessionStorage.getItem("LocationId")) {
        this.getServerTime();
        clearInterval(ServerTimeInterval);
        return;
      }
    }, 1000);
  }
  fnEnableEmergencyAccess() {

    //=======Emergency user loop ==============================
    if (this.ISONCEnabled == false) {
      this.dproducts = this.dproducts.filter(a => a.ID != 4)// .Name !== 'Enable Emergency Access')
    }
    else {
      if (sessionStorage.getItem("EmergencyAccessEnabled")) {
        this.dproducts.forEach(ele => {
          if (ele.ID == 4) {
            if (sessionStorage.getItem("EnableEmergencyAccess"))
              ele.Name = 'Disable Emergency Access'
            else
              ele.Name = 'Enable Emergency Access'
          }
        })
      }
      else {
        this.dproducts = this.dproducts.filter(a => a.ID != 4)
      }

    }
    return this.dproducts;
    /////////////////////////////////////////////////////////////////////////
  }
  GetAttribute() { }

  selectedmenu: string;
  public result: any;
  onLocationChange() {
    if (this.LocationForm.value.ServiceSite != null && this.LocationForm.value.ServiceSite != undefined) {
      sessionStorage.setItem("LocationId", this.LocationForm.value.ServiceSite);
      sessionStorage.removeItem("calenderLocations");
      sessionStorage.removeItem("selectedProviders");
      this.LocationForm.patchValue({
        facilityName: this.lstLocations.filter(a => a.locationId.toString() == this.LocationForm.value.ServiceSite)[0].facilityName
      });
      let twillioPhoneNum = this.lstLocations.filter(x => x.locationId == Number(this.LocationForm.value.ServiceSite))[0].phiscalPhoneNum
      sessionStorage.setItem("TwillioPhoneNumber", twillioPhoneNum);
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("encounterid");
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(["Appointments"]));
    }
  }

  OnNavigateLocationChanges(Loc: any) {}
  location: any;
  async getLocationsByloginUser() {
 
    await this.sharedService.getLocationsByLoginUser().subscribe(data => {
      this.location = Number(data);
      if( this.lstLocations.filter(a => a.locationId == this.location).length == 0 || this.location == 0){
          this.location = this.lstLocations[0].locationId;
      }
      let facilityName = this.lstLocations.filter(a => a.locationId.toString() == this.location.toString())[0].facilityName;
      this.LocationForm.patchValue({
        ServiceSite: this.location,
        facilityName: facilityName
      }); 
      sessionStorage.setItem("LocationId", this.LocationForm.value.ServiceSite);
      let twillioPhoneNum = this.lstLocations.filter(x => x.locationId == this.location)[0].phiscalPhoneNum
      sessionStorage.setItem("TwillioPhoneNumber", twillioPhoneNum);

      if (sessionStorage.getItem("LocationId"))
        this.sharedService.getservercurrentdate().subscribe(result => {
          sessionStorage.setItem("PatBoardDate", new Date(result).toDateString());
        });
    });

  }

  itemClick(data) {
    if (data.id.length > 1) {
      this.currentselectedouteritem = this.outermenulist.find((outermenu: OuterMenu) => outermenu.id == data.id.substring(0, 1));
      localStorage.removeItem("submenuId");
      if (data.routelink != null) {
        CommonComponents.demoheaderVisibility = true;

        if (data.name == "New Patient" || data.name == "CQMS Dashboard" || data.name == "CQMS Configuaration" || data.name == "Patient Board" || data.name == "Patient Messages" || data.name == "Patient Referrals") {
          sessionStorage.removeItem("patientId");
          sessionStorage.removeItem("patientName");
          sessionStorage.removeItem("encounterid");
          sessionStorage.setItem("providerPatientBoard", 'true');
          sessionStorage.removeItem("patientDob");
          sessionStorage.removeItem("searchPatId");
          CommonComponents.patientId = 0;
          CommonComponents.patientName = '';
          this.bannerService.toggle(Number("-1"));
        } else {
          this.bannerService.toggle(Number(sessionStorage.getItem("patientId")));
        }
        this.clearLock();
        if (data.name == "Documents" || data.name === "Check In" || data.name === "Demographics" || data.name === "Past Notes" || data.name === "Patient Appointments" || data.name === "Summary" || data.name === "Clinical Summary") {
          sessionStorage.removeItem("AlertsheaderIconVisibility");
          sessionStorage.removeItem("hideDocumentsHeader");

          if (sessionStorage.getItem("patientId") == null || sessionStorage.getItem("patientId") == "" || sessionStorage.getItem("patientId") == undefined) {
            this.toastr.warning("Please select Patient Id");
            return;
          } else {
            //alert("approute" + data.routelink);
            this.route.navigateByUrl(data.routelink);
          }
        } if (data.name == 'Security') {
          sessionStorage.setItem("DisplayCategeory", 'false')
          this.router.navigate(['/AdminSecurity']);
        } else {
          if (data.routelink == "/NewAppointment") {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
              this.router.navigate(['/NewAppointment']));
          } else if (data.routelink == "/AdminDashboard" && data.name == "MU") {
            if (this.ISONCEnabled == true)
              this.router.navigate(['/AdminDashboard']);
          } else {
            // alert("approute" + data.routelink);
            this.route.navigateByUrl(data.routelink);
          }
        }
        localStorage.setItem("submenuId", data.id);
        let mymenuItems = this.outermenulist;
        let mainmId = data.id;
        let mainmenuid = mainmId.split("_")[0];
        if (mymenuItems) {
          for (let i = 0; i < mymenuItems.length; i++) {
            if (mymenuItems[i].items) {
              for (let j = 0; j < mymenuItems[i].items.length; j++) {
                if (data.id == mymenuItems[i].items[j].id) {  //look for match with name
                  mymenuItems[i].items[j].activemenu = true;  //add two
                } else {

                  mymenuItems[i].items[j].activemenu = false;
                }
              }
            }
          }
          localStorage.removeItem("menuId");
          for (let m = 0; m < mymenuItems.length; m++) {

            if (mainmenuid == mymenuItems[m].id) {  //look for match with name
              mymenuItems[m].activemenu = true;  //add two
              localStorage.setItem("menuId", mymenuItems[m].id);
            } else {
              mymenuItems[m].activemenu = false;
            }
          }

          this.outermenulist = mymenuItems;
        }
        sessionStorage.removeItem("displayappDate");
        sessionStorage.removeItem("displayappDate1");
        sessionStorage.removeItem("isCQMSVisitNote");
        sessionStorage.removeItem("Cqmsyear");
        sessionStorage.removeItem("WeekValue");
        sessionStorage.removeItem("monthValue");
        sessionStorage.removeItem("RadioValue");
        sessionStorage.removeItem("FromDate");
        sessionStorage.removeItem("ToDate");
        sessionStorage.removeItem("yearbuttoncolor");
        sessionStorage.removeItem("Q1buttoncolor");
        sessionStorage.removeItem("Q2buttoncolor");
        sessionStorage.removeItem("Q3buttoncolor");
        sessionStorage.removeItem("Q4buttoncolor");
        localStorage.removeItem("isBackBtnVisibleInVisitNotes");
        sessionStorage.setItem("visitNoteAlertsheaderVisibility", "true");
        sessionStorage.removeItem("IsOldPatient");
        sessionStorage.removeItem("FormScreenType");
        sessionStorage.removeItem("CheckedinStatus");
        sessionStorage.removeItem("NavigationType");
        
        this.procSessionValue = null;
        this.sideSessionValue = null;
        this.levelsSessionValue = null;
        this.OthersSessionValue = null;
        this.typesSessionValue = null;
        this.cptCodesSessionValue = null;

      }
    }

  }

  HyperLinkClicks(data) {
    if (data != "") {
      if (data == 'Patient Board') {
        var mainmenuName = 'Calendar'
      } else if (data == 'Demographics') {
        var mainmenuName = 'Patient Chart'
      } else if (data == "New Appointment") {
        var mainmenuName = 'Calendar'
      } else if (data == "Documents") {
        var mainmenuName = 'Patient Chart'
      } else if (data == "Patient Appointments") {
        var mainmenuName = 'Patient Chart'
      } else if (data == "Patient Referrals") {
        var mainmenuName = 'Trackers'
      } else if (data == "Dashboard") {
        var mainmenuName = 'Home'
      } else if (data == "Nurse Dashboard") {
        var mainmenuName = 'Home'
      } else if (data == "Clerk Dashboard") {
        var mainmenuName = 'Home'
      }

      localStorage.removeItem("submenuId");
      CommonComponents.demoheaderVisibility = true;
      this.bannerService.toggle(Number(sessionStorage.getItem("patientId")));
      let mymenuItems = this.outermenulist;
      if (mymenuItems) {
        for (let i = 0; i < mymenuItems.length; i++) {
          if (mymenuItems[i].items) {
            for (let j = 0; j < mymenuItems[i].items.length; j++) {
              if (data == mymenuItems[i].items[j].name) {
                localStorage.setItem("submenuId", mymenuItems[i].items[j].id);
                mymenuItems[i].items[j].activemenu = true;
              } else {

                mymenuItems[i].items[j].activemenu = false;
              }
            }
          }
        }
        localStorage.removeItem("menuId");
        for (let m = 0; m < mymenuItems.length; m++) {

          if (mainmenuName == mymenuItems[m].name) {
            mymenuItems[m].activemenu = true;
            localStorage.setItem("menuId", mymenuItems[m].id);
          } else {
            mymenuItems[m].activemenu = false;
          }
        }

        this.outermenulist = mymenuItems;
      }
      sessionStorage.removeItem("isCQMSVisitNote");
      sessionStorage.removeItem("Cqmsyear");
      sessionStorage.removeItem("WeekValue");
      sessionStorage.removeItem("monthValue");
      sessionStorage.removeItem("RadioValue");
      sessionStorage.removeItem("FromDate");
      sessionStorage.removeItem("ToDate");
      sessionStorage.removeItem("yearbuttoncolor");
      sessionStorage.removeItem("Q1buttoncolor");
      sessionStorage.removeItem("Q2buttoncolor");
      sessionStorage.removeItem("Q3buttoncolor");
      sessionStorage.removeItem("Q4buttoncolor");
      //localStorage.removeItem("isBackBtnVisibleInVisitNotes");
      sessionStorage.setItem("visitNoteAlertsheaderVisibility", "true");
      this.procSessionValue = null;
      this.sideSessionValue = null;
      this.levelsSessionValue = null;
      this.OthersSessionValue = null;
      this.typesSessionValue = null;
      this.cptCodesSessionValue = null;
      //  }
    }
  }

  tempsubmenu: string;
  item: any[];
  itemslist: OuterMenu[];
  subitem: any;
  currentselectedouteritem: any;
  showingsubmenu(e) {
    this.subitem = this.outermenulist.find((outermenu: OuterMenu) => outermenu.name == e.rootItem.innerText);

    this.tempsubmenu = this.subitem.icon;
    this.subitem.icon = this.subitem.icon2;
    this.subitem.icon2 = this.tempsubmenu;
    if (this.currentselectedouteritem != null) {
      this.tempsubmenu = this.currentselectedouteritem.icon;
      this.currentselectedouteritem.icon = this.currentselectedouteritem.icon2;
      this.currentselectedouteritem.icon2 = this.tempsubmenu;
      this.currentselectedouteritem = null;
    }
  }

  Hidingsubmenu(e) {
    this.subitem = this.outermenulist.find((outermenu: OuterMenu) => outermenu.name == e.rootItem.innerText);
    this.tempsubmenu = this.subitem.icon;
    this.subitem.icon = this.subitem.icon2;
    this.subitem.icon2 = this.tempsubmenu;

  }
  step = 0;
  temp: string;
  setStep(index: number, item: Menu) {
    this.step = index;
    this.imgflag = !this.imgflag;
    this.imgflag2 = !this.imgflag2;
    this.temp = item.icon;
    item.icon = item.icon2;
    item.icon2 = this.temp;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  update(item: Menu) {
    this.imgflag = !this.imgflag;
    this.imgflag2 = !this.imgflag2;
    this.temp = item.icon2;
    item.icon2 = item.icon;
    item.icon = this.temp;
  }


  OuterMenuClick(e, item: Menu) {
    if (e.itemData.routelink != null) {
      if (e.itemData.submenutext == "New Patient") {
        CommonComponents.patientId = null;
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("encounterid");
      }
      this.clearLock();
      // alert("appOuterMenuClick" + e.itemData.routelink);
      this.router.navigateByUrl(e.itemData.routelink);
    }
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(CheckedinComponent, {
      width: '1100px',
      height: '600px'

    });

    dialogRef.afterClosed().subscribe(result => { });
  }

  @SessionStorage() procSessionValue: any;
  @SessionStorage() sideSessionValue: any;
  @SessionStorage() levelsSessionValue: any;
  @SessionStorage() OthersSessionValue: any;
  @SessionStorage() typesSessionValue: any;
  @SessionStorage() cptCodesSessionValue: any;

  loginSession: ILoginSessionByLoginUser;
  onlogout() {
    this.mapValuesFromCheckUserLogin();
    this.sharedService.GetLoginSessionByLoginUser(this.loginSession).subscribe((results: any) => {
      this.result = results;
      this.removeSessionObject();

    }, (err: any) => {
      console.log(err);
      this.removeSessionObject();
    });

  }
  removeSessionObject() {
    try {

      if (this.outermenulist)
        this.outermenulist = [];
      if (this.originalArry)
        this.originalArry = [];
      this.isLoggedIn$ = false;
      this.clearLock();
      this.procSessionValue = null;
      this.sideSessionValue = null;
      this.levelsSessionValue = null;
      this.OthersSessionValue = null;
      this.typesSessionValue = null;
      this.cptCodesSessionValue = null;
      localStorage.removeItem('userToken');
      localStorage.removeItem('role');
      localStorage.removeItem('clinicToken');
      localStorage.removeItem('TokenStartTime');
      localStorage.removeItem('TokenEndTime');
      localStorage.removeItem('ordernoteheaderVisibility');
      sessionStorage.removeItem("rxfromsearch");
      sessionStorage.removeItem("modifyDrugAllerg");
      sessionStorage.removeItem("modifyFoodAllerg");
      sessionStorage.removeItem("modifyEnvAllerg");
      CommonComponents.patientId = null;
      CommonComponents.patientName = '';
      CommonComponents.userName = '';
      CommonComponents.encounterId = null;
      CommonComponents.patientAge = '';
      CommonComponents.patientGender = '';
      CommonComponents.headerVisibility = false;
      CommonComponents.pumpRefillVisibility = false;

      // sessionStorage.clear();
      this.closeslide("close");
      this.closeslide1("close")
      sessionStorage.removeItem("displayappDate");
      sessionStorage.removeItem("displayappDate1");
      sessionStorage.removeItem("isCQMSVisitNote");
      sessionStorage.removeItem("Cqmsyear");
      sessionStorage.removeItem("WeekValue");
      sessionStorage.removeItem("monthValue");
      sessionStorage.removeItem("RadioValue");
      sessionStorage.removeItem("FromDate");
      sessionStorage.removeItem("ToDate");
      sessionStorage.removeItem("yearbuttoncolor");
      sessionStorage.removeItem("Q1buttoncolor");
      sessionStorage.removeItem("Q2buttoncolor");
      sessionStorage.removeItem("Q3buttoncolor");
      sessionStorage.removeItem("Q4buttoncolor");
      localStorage.removeItem('dashboardData');
      localStorage.removeItem('cols');
      sessionStorage.removeItem("role");
      sessionStorage.removeItem("calparams");
      sessionStorage.removeItem("loginUserId");
      sessionStorage.removeItem("loginRole");
      sessionStorage.removeItem("TwillioPhoneNumber");
      localStorage.removeItem("isBackBtnVisibleInVisitNotes");
      sessionStorage.removeItem("searchPatId");
      sessionStorage.removeItem("IsOldPatient");
      sessionStorage.removeItem("isParentFacility");
      sessionStorage.removeItem("UserIdentity");
      var uId = encodeURIComponent(sessionStorage.getItem("userId"));
      var sessionId = sessionStorage.getItem("UserSessionID");
      var facilityId = sessionStorage.getItem('FacilityId');
      this.loginSession = new ILoginSessionByLoginUser();
      this.loginSession.userId = uId;
      this.loginSession.facilityId = facilityId;
      this.loginSession.loginSessionId = sessionId;
      this.loginSession.selectMode = 'Update';
      this.patsrch.clearSearch();
      this.taskandmessage.clearTaskMessageSearchValue();
      sessionStorage.clear();
      this.cookieService.set('usertoken', null, null, '/', null, false, "Strict");
      this.cookieService.set('clinictoken', null, null, '/', null, false, "Strict");
      $('#usertoken').val(null);
      $('#clinictoken').val(null);
      this.router.navigate(['/login']);
    }
    catch (ex) {
      sessionStorage.clear();
      this.router.navigate(['/login']);
    }
    //  this.sessionByUserLogin();
  }
  mapValuesFromCheckUserLogin() {
    var loginUserId = encodeURIComponent(sessionStorage.getItem("userId"));
    var getLoginSessionId = sessionStorage.getItem("UserSessionID");
    var getLoginFacilityId = sessionStorage.getItem('FacilityId');
    this.loginSession = new ILoginSessionByLoginUser();
    this.loginSession.userId = loginUserId;
    this.loginSession.facilityId = getLoginFacilityId;
    this.loginSession.loginSessionId = getLoginSessionId;
    this.loginSession.selectMode = 'Update';

  }

  closeslide(e: any) {
    if (e === "close") {
      this.sidenav.close();
    }
  }
  closeslide1(e: any) {
    if (e === "close") {
      this.sidenav1.close();
      this.IsTaskMessage = false;
      this.InternetShow = false;
    }
  }
  closeDialog() {
    document.getElementById('sigpad').setAttribute('src', '');
    $("#SignaturepadDialog").removeClass("mydailog");
    $("#SignaturepadDialog").addClass("mydailog-d");
    document.getElementById("sigdialog").style.display = 'none';
  }

  close() {
    this.sidenav1.close();
    this.IsTaskMessage = false;
    this.InternetShow = false;
  }
  onValueChanged(val: any) {
    this.selectMenuName = val;
    if (this.selectMenuName === "Logout") {
      this.onlogout();
      $("#SignaturepadDialog").removeClass("mydailog");
      $("#SignaturepadDialog").addClass("mydailog-d");
      document.getElementById('sigpad').setAttribute('src', '');
      document.getElementById("sigdialog").style.display = 'none';

    }
    if (this.selectMenuName === "My Profile") {
      this.router.navigate(['/MyProfile']);
    }
    if (this.selectMenuName === "View Permissions") {
      this.router.navigate(['/RolesandPermView']);

    }
    if (this.selectMenuName === "Change Password") {
      this.router.navigate(['/ChangePassword']);
    }
    if (this.selectMenuName === "Settings") {
      this.router.navigate(['/Settings']);
    }
    const _auditLog: AuditLog = new AuditLog();
    _auditLog.PatientID = 0;
    _auditLog.SPName = "EMR_EmergencyAccess_UserRoles";

    if (this.selectMenuName === "Enable Emergency Access") {
      this.selectMenuName = "Disable Emergency Access"
      this.dproducts.forEach(ele => {
        if (ele.Name == 'Enable Emergency Access')
          ele.Name = 'Disable Emergency Access'
      })
      sessionStorage.setItem("EnableEmergencyAccess", "1");
      _auditLog.ChangedValues = "Emergency Access Enabled";
      _auditLog.SPName = 'USP_EMR_EmergencyAccess_UserRoles'
      this.sharedService.selectCopyPrintAuditLog(_auditLog).subscribe();
      this.getmainMenuList();
      window.location.reload();
    }
    else if (this.selectMenuName === "Disable Emergency Access") {
      this.selectMenuName = "Enable Emergency Access"
      sessionStorage.removeItem("EnableEmergencyAccess");
      this.dproducts.forEach(ele => {
        if (ele.Name == 'Disable Emergency Access')
          ele.Name = 'Enable Emergency Access'
      });
      _auditLog.ChangedValues = "Emergency Access Disabled";
      _auditLog.SPName = 'USP_EMR_EmergencyAccess_UserRoles'
      this.sharedService.selectCopyPrintAuditLog(_auditLog).subscribe();
      this.getmainMenuList();
      window.location.reload();
    }
  }
  checkEmergencyAccess() {
    try {
      var strpath = location.href;
      if (strpath.includes('login')) {
        return false;
      } else if (strpath.includes('Activation')) {
        return false;
      }
      else if (strpath.includes('Register')) {
        return false;
      }
      else if (sessionStorage.getItem("EnableEmergencyAccess")
        && sessionStorage.getItem("userId"))
        return true;



      return false;

    }
    catch (ex) {
      return false;
    }
  }

  clearLock() {
    this.lockService.deleteLockUsersInfo(sessionStorage.getItem("userId")).subscribe(data => {
    },
      (err: any) => console.log(err)
    );
  }


  public onSidenavClose = () => {

  }
  SideNav() {
    this.showFiller2 = !this.showFiller2
  }
  clickBack() {
    if (this.previousTrigger) { this.previousTrigger.closeMenu() }
  }

  openSubMenu(trigger: MatMenuTrigger) {


    if (this.previousTrigger && this.previousTrigger.menuOpen) {
      this.previousTrigger.closeMenu();
    }
    trigger.openMenu();
    this.previousTrigger = trigger;

  }

  hideSubMenu() {
    if (this.previousTrigger && this.previousTrigger.menuOpen)
      this.previousTrigger.closeMenu();
  }

  checkSession() {
    try {
      var strpath = location.href;
      if (strpath.includes('login')) {
        return false;
      } else if (strpath.includes('Activation')) {
        return true;
      }
      else if (strpath.includes('Register')) {
        return false;
      } else {
        if (sessionStorage.getItem("userId") != null && sessionStorage.getItem("userId") != undefined)
          return true;
        else
          //   this.router.navigate(['/login']);
          return false;
      }
    }
    catch (ex) {
      return false;
    }
  }

  public TaksCount: any;
  async getcountTaskMessages() {
    clearInterval(this.intcheck);
    try {
      if (sessionStorage.getItem("userId") && this.IsMsgandTask) {
        await this.TasksMessageService.getMessagesTasksCount().subscribe(data => {
          this.resetTaskInterval();
          this.TaksCount = data;
        }, error => {

        });
      }
    }
    catch (ex) {
      this.TaksCount = 0;
      //alert(ex);
    }
  }

  public lstLocations: ILocationDetails[] = [];
  public selectedLocation = new ILocationDetails();

  async getUserLocations() {
    await this.sharedService.getLocationsByUser().subscribe(data => {
      this.lstLocations = data;
      sessionStorage.setItem('UserLocations', JSON.stringify(this.lstLocations));
      this.getLocationsByloginUser();
    });

  }

  menuClick(menu: OuterMenu) {
    if (menu.name == "RX") {
      this.route.navigateByUrl(menu.routelink);
    }
    if (menu.name == "Messages") {
      if (configuration.IsTaskAndMessages) {

        if (menu && this.outermenulist.length > 0) {
          for (let m = 0; m < this.outermenulist.length; m++) {

            if (menu.id == this.outermenulist[m].id) {
              this.outermenulist[m].activemenu = true;
            } else {
              this.outermenulist[m].activemenu = false;
            }
          }
        }

        localStorage.removeItem("submenuId");
        localStorage.removeItem("menuId");
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientDob");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("encounterid");
        sessionStorage.setItem("providerPatientBoard", 'true');
        sessionStorage.removeItem("patientDob");
        sessionStorage.removeItem("IsOldPatient");
        localStorage.setItem("menuId", menu.id);
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.route.navigateByUrl(menu.routelink);
      }
    }
    if (menu.name == 'Messages') {
      sessionStorage.setItem("TaskMessage", "true")
    } else {
      sessionStorage.setItem("TaskMessage", "false")
    }
  }

  originalArry: OuterMenu[] = [];
  outernewarrayMenuList: OuterMenu[] = [];
  async getmainMenuList() {

    this.originalArry = [];

    this.outermenulist.length = 0;
    await this.sharedService.getOuterMenuList().subscribe(data => {
      this.originalArry = data;
      this.outermenulist = Object.assign([], this.originalArry);
      if (sessionStorage.getItem("role") != null) {
        if (sessionStorage.getItem("role") == "Admin") {

          this.outermenulist = this.outermenulist.filter(x => x.name != "RX");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "New Patient");
        } else if (sessionStorage.getItem("role") == "Transcriptionist") {
          this.outermenulist = this.outermenulist.filter(x => x.name != "RX" && x.name != "Admin");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "New Patient");
        }
        else if (sessionStorage.getItem("role") == "Office Manager" || sessionStorage.getItem("role") == "Insurance") {
          this.outermenulist = this.outermenulist.filter(x => x.name != "RX" && x.name != "Admin");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "New Patient");
        }
        else if (sessionStorage.getItem("role") == "Doctor" || sessionStorage.getItem("role") == "Nurse Practitioner" || sessionStorage.getItem("role") == "Physician Assistant") {

          this.outermenulist = this.outermenulist.filter(x => x.name != "Admin");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "Dashboard" || x.name == "New Patient");
        } else if (sessionStorage.getItem("role") == "Clerk") {
          this.outermenulist = this.outermenulist.filter(x => x.name != "RX" && x.name != "Admin");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "Clerk Dashboard" || x.name == "New Patient");
        }
        else {
          this.outermenulist = this.outermenulist.filter(x => x.name != "RX" && x.name != "Admin");
          this.outermenulist[0].items = this.outermenulist[0].items.filter(x => x.name == "Nurse Dashboard" || x.name == "New Patient");
        }
      } else {
        this.originalArry = [];
        this.outermenulist = [];
      }
      let getsubmenuId = localStorage.getItem('submenuId');
      let mymenuItems = this.outermenulist;
      if (getsubmenuId != null) {
        let mainmId = getsubmenuId;
        let mainmenuid = mainmId.split("_")[0];
        if (mymenuItems) {
          if (getsubmenuId && this.outermenulist.length > 0) {
            for (let i = 0; i < mymenuItems.length; i++) {
              if (mymenuItems[i].items) {
                for (let j = 0; j < mymenuItems[i].items.length; j++) {
                  if (getsubmenuId == mymenuItems[i].items[j].id) {
                    mymenuItems[i].items[j].activemenu = true;
                  } else {

                    mymenuItems[i].items[j].activemenu = false;
                  }
                }
              }
            }
          }
        }
      }
      let getmenuId = localStorage.getItem('menuId');
      if (getmenuId && this.outermenulist.length > 0) {
        for (let m = 0; m < this.outermenulist.length; m++) {

          if (getmenuId == this.outermenulist[m].id) {  //look for match with name
            this.outermenulist[m].activemenu = true;  //add two
          } else {
            this.outermenulist[m].activemenu = false;
          }
        }
      }
    });
  }


  patientboardNavigation(event) {
    this.HyperLinkClicks('Patient Board');
    sessionStorage.removeItem("patientId");
    sessionStorage.removeItem("patientName");
    sessionStorage.removeItem("encounterid");
    sessionStorage.setItem("providerPatientBoard", 'true');
    CommonComponents.patientId = 0;
    CommonComponents.patientName = '';
    this.bannerService.toggle(Number("-1"));
    this.InternetShow = false;
    setTimeout(() => {
      this.router.navigateByUrl('/Appointments');
    }, 1000);

  }
  funHelp() {
    let curURL = localStorage.getItem('activeurl');
    let urlBase = configuration.emrHelpUrl;
    var userID = encodeURIComponent(sessionStorage.getItem("userId"));
    var sessionId = sessionStorage.getItem("UserSessionID");

    const target = '_blank';
    const widthandeight = 'width=1280,height=2000,';
    if (curURL == 'AdminSecurity') {
      window.open(urlBase + '/AdminModule/AdminModule.html#Security' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Scheduler') {
      window.open(urlBase + '/AdminModule/AdminModule.html#Scheduler' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Billing') {
      window.open(urlBase + '/AdminModule/AdminModule.html#Billing' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Clinic') {
      window.open(urlBase + '/AdminModule/AdminModule.html#Clinical' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'AdminRx') {
      window.open(urlBase + '/AdminModule/AdminModule.html#Rx' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'AdminSystem') {
      window.open(urlBase + '/AdminModule/AdminModule.html#System' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Personal') {
      window.open(urlBase + '/Demographics/Demographics.html#Personal' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Emergency') {
      window.open(urlBase + '/Demographics/Demographics.html#Emergency' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Insurance') {
      window.open(urlBase + '/Demographics/Demographics.html#Insurance' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Accounts') {
      window.open(urlBase + '/Demographics/Demographics.html#AccountDetails' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Employment') {
      window.open(urlBase + '/Demographics/Demographics.html#EmploymentDetails' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Pharmacy') {
      window.open(urlBase + '/Demographics/Demographics.html#Pharmacy' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Authorization') {
      window.open(urlBase + '/Demographics/Demographics.html#Authorization' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Alerts') {
      window.open(urlBase + '/Demographics/Demographics.html#Alerts' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Notes') {
      window.open(urlBase + '/Demographics/Demographics.html#Notes' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Forms') {
      window.open(urlBase + '/Demographics/Demographics.html#Forms' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Demographics/Referral') {
      window.open(urlBase + '/Demographics/Demographics.html#Referral' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'CalTemplate') {
      window.open(urlBase + '/CalendarTemplates/CalendarTemplates.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'homeorders') {
      window.open(urlBase + '/OrderTrackers/OrderTrackers.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'patientreferraltracker') {
      window.open(urlBase + '/PatientReferrals/PatientReferrals.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Vitals') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Vitals' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Intake') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Intake' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Assessments') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Assessment' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'CC') {
      window.open(urlBase + '/VisitNote/VisitNote.html#CC' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'HPI') {
      window.open(urlBase + '/VisitNote/VisitNote.html#HPI' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Hx') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Hx' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ROS') {
      window.open(urlBase + '/VisitNote/VisitNote.html#ROS' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Allergies') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Allergies' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'A/C') {
      window.open(urlBase + '/VisitNote/VisitNote.html#AC' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'PE') {
      window.open(urlBase + '/VisitNote/VisitNote.html#PE' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Cervical') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Cervical' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Thoracic') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Thoracic' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Lumbar') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Lumbar' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Dx') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Dx' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Rx') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Rx' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Orders') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Orders' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Procedures') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Procedures' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Discussions') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Discussions' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Follow-Up') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Followup' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Plan') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Plan' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ProgressNotes') {
      window.open(urlBase + '/VisitNote/VisitNote.html#VisitNotes' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ConsentForms/95') {
      window.open(urlBase + '/VisitNote/VisitNote.html#Forms' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'CheckInalerts') {
      window.open(urlBase + '/PatientBoard/PatientBoard.html#Checked-Instatus' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'Appointments') {
      window.open(urlBase + '/PatientBoard/PatientBoard.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORImportantInstructions') {
      window.open(urlBase + '/OrNote/ORNote.html#Consents' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORAllergiesA/Cs') {
      window.open(urlBase + '/OrNote/ORNote.html#Allergies' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORAssessment') {
      window.open(urlBase + '/OrNote/ORNote.html#Assessment' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORORRecord') {
      window.open(urlBase + '/OrNote/ORNote.html#ORRecord' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORORRecord') {
      window.open(urlBase + '/OrNote/ORNote.html#ORRecord' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORFluoroImages') {
      window.open(urlBase + '/OrNote/ORNote.html#FluoroImages' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORPostSurgical') {
      window.open(urlBase + '/OrNote/ORNote.html#PostSurgical' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORPerioperativeOrders') {
      window.open(urlBase + '/OrNote/ORNote.html#PerioperativeOrders' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ORPostOp-Follow-up') {
      window.open(urlBase + '/OrNote/ORNote.html#Post-OpFollow-up' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'DynamicIntakeSettings/Intake') {

      window.open(urlBase + '/Dynamic_Intake_Settings_files/DynamicIntakeSettings.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'ProviderCalender') {

      window.open(urlBase + '/ProviderCalendar/ProviderCalendar.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
    else if (curURL == 'DocumentLibrary') {

      window.open(urlBase + '/DocumentLibrary/DocumentLibrary.html' + '?loginId=' + userID + '&sessionId=' + sessionId, target, widthandeight);
    }
  }
  fnTasksMessages() {
    const dialogRef = this.dialog.open(TasksandmessagesTabComponent, {
      data: 'TaskSideNav'
    });

    dialogRef.afterClosed().subscribe(result => {
    });

  }

  //****Internal Chat Application */
  internalstaffchatNavigation(event) {
    sessionStorage.removeItem("patientId");
    sessionStorage.removeItem("patientName");
    sessionStorage.removeItem("encounterid");
    CommonComponents.patientId = 0;
    CommonComponents.patientName = '';
    this.bannerService.toggle(Number("-1"));
    //this.router.navigateByUrl('/Intstaffchat');
    this.router.navigateByUrl('/tasksandmessages');
  }

  LocationTimer: any;
  LocationTimer_DateFormat: Date;
  getServerTime() {
    this.dateservice.getservercurrentdate().subscribe(result => {
      this.LocationTimer_DateFormat = new Date(result);
      // result = this.datePipe.transform(result, "MM/dd/yyyy hh:mm:ss a");
      //this.LocationTimer = result.replace('T', ' ');

      setInterval(() => {
        this.LocationTimer_DateFormat.setSeconds(this.LocationTimer_DateFormat.getSeconds() + 1)
        this.LocationTimer = this.datePipe.transform(this.LocationTimer_DateFormat, "MM/dd/yyyy hh:mm:ss a").replace('T', ' ');
      }, 1000);

    })
  }


}
